/**
 * Product access checks used for shell onboarding (preload / fetch gating).
 */

export function hasProductAccessWithRoles(
  userStore: { getProductAccess: (p: string) => boolean; getProductAccessOnRoles: (p: string) => boolean },
  product: string
): boolean {
  return (
    userStore.getProductAccess(product) &&
    userStore.getProductAccessOnRoles(product)
  )
}

export function shouldFetchOnboardingData(userStore: {
  getProductAccess: (p: string) => boolean
  getProductAccessOnRoles: (p: string) => boolean
}): boolean {
  return (
    hasProductAccessWithRoles(userStore, 'marketing') ||
    hasProductAccessWithRoles(userStore, 'service') ||
    hasProductAccessWithRoles(userStore, 'commerce')
  )
}
